<template lang="pug">
  v-navigation-drawer(app width="220" permanent style="background: #4292fc" dark)
    v-layout(column fill-height)
      v-toolbar(flat class="transparent")
      v-list(v-if="isCurator")
        v-list-tile(v-for="item in curatorItems", :key="item.title", :to="item.link")
          v-list-tile-action
            v-icon {{ item.icon }}
          v-list-tile-content
            v-list-tile-title(style="overflow: visible") {{ $t(item.title) }}
      v-list(v-else)
        v-list-tile(v-for="item in userItems", :key="item.title", :to="item.link")
          v-list-tile-action
            v-icon {{ item.icon }}
          v-list-tile-content
            v-list-tile-title {{ $t(item.title) }}
      v-divider(v-if="isCurator")
      div(v-if="isCurator", class="link")
        v-icon(class="link__icon") archive
        a(class="link__title",
          href='/api/report/download-excel',
          target="_blank",
          rel="noopener noreferrer") {{$t('common.download')}}
</template>

<script>
export default {
  name: 'SideBar',
  data: () => ({
    userItems: [
      { title: 'common.btnReporting', icon: 'dashboard', link: '/main/reporting' },
      { title: 'common.btnDraft', icon: 'file_copy', link: '/main/draft' },
      { title: 'common.btnArchive', icon: 'storage', link: '/main/archive' },
      { title: 'common.btnProfile', icon: 'perm_contact_calendar', link: '/main/profile' }
    ],
    curatorItems: [
      { title: 'common.respondent', icon: 'supervisor_account', link: '/main/respondents' },
      { title: 'common.btnArchive', icon: 'storage', link: '/main/curator-archive' },
      { title: 'common.btnReporting', icon: 'dashboard', link: '/main/curator-reports' }
    ]
  }),
  computed: {
    isCurator() {
      return JSON.parse(sessionStorage.getItem('isCurator'))
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  display: flex;
  justify-content: start;
  align-items: center;
  padding-left: 40px;
  padding-top: 24px;
  &__icon {
    margin-right: 16px;
  }
  &__title {
    color: white;
    font-size: 16px;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MainPage/common/SideBar.vue